export const inr = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  return "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(n));
};

export const inrShort = (n) => {
  if (!n) return "₹0";
  const abs = Math.abs(n);
  if (abs >= 10000000) return `₹${(n / 10000000).toFixed(2)}Cr`;
  if (abs >= 100000) return `₹${(n / 100000).toFixed(2)}L`;
  if (abs >= 1000) return `₹${(n / 1000).toFixed(1)}K`;
  return inr(n);
};

export const budgetRange = (min, max) => `${inrShort(min)} – ${inrShort(max)}`;
